import { render, staticRenderFns } from "./SeatDetails.vue?vue&type=template&id=71b96e7c&"
import script from "./SeatDetails.vue?vue&type=script&lang=js&"
export * from "./SeatDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports